import React from 'react'
import WebComponentContainer from '../generic/WebComponentContainer'

const HistoryComponentWrapper = ({ experienceState, year, make, color, engine, drivetrain, model, trim, vinResults, entry, mileage, transmission, contactPageIsLoaded, showInValidHistoryComponentForm, globalState }) => {
  const { acceptsRv, offerCode, lnxCode, isIneligibleVehiclesEnabled, isAssigned, vehicleIntoAuction, isAdmin, isCobrand, allowIneligibleVehicle, theme } = experienceState
  const allowIneligibleVehicleForCobranding = allowIneligibleVehicle && isCobrand
  const allowIneligibleVehicles = isAssigned || allowIneligibleVehicleForCobranding
  const allowIneligibleVehiclesForWebComponent = isIneligibleVehiclesEnabled && allowIneligibleVehicles && !vehicleIntoAuction

  return (
    <WebComponentContainer pageLoadingComplete={contactPageIsLoaded} withLoader={true} location={'history'} theme={theme}>
      <history-state-hydrator
        year-id={year.yearId}
        make-id={make.makeId}
        model-id={model.modelId}
        trim-id={trim.trimId}
        color-id={color.colorId}
        transmission-id={transmission.transmissionId}
        engine-id={engine.engineId}
        drivetrain-id={drivetrain.drivetrainId}
        drivetrain={drivetrain.displayName}
        vin={vinResults ? vinResults.vin : null}
        mileage={mileage}
        offer-code={offerCode}
        lnx-code={lnxCode}
        entry={entry}
        show-form-validation={showInValidHistoryComponentForm}
        accepts-rv={acceptsRv}
        allow-ineligible-vehicle-submission={allowIneligibleVehiclesForWebComponent}
        is-admin={isAdmin}
        align-left={true}
        theme={theme}>
        <vehicle-history />
      </history-state-hydrator>
    </WebComponentContainer>
  )
}

export default HistoryComponentWrapper
